/**
 * Usage Insights dashboard tab — gated by LaunchDarkly `usage-insights`
 * (including camelCase variants commonly returned by `useFlags()`).
 */

export function isUsageInsightsLdEnabled(flags: Record<string, unknown> | undefined): boolean {
  if (!flags || typeof flags !== "object") {
    return false;
  }
  const f = flags as Record<string, unknown>;
  return (
    f.usageInsights === true ||
    f.usageinsights === true ||
    f["usage-insights"] === true
  );
}
